import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=5a9323b7&scoped=true&"
import script from "./PartnersPage.vue?vue&type=script&lang=js&"
export * from "./PartnersPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=5a9323b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9323b7",
  null
  
)

export default component.exports